import React from 'react';
import { CheckoutButton } from '../CheckoutButton';
import { GuaranteeNote } from '../GuaranteeNote';
import { BUY_LABEL } from '../../data/checkout';
export function FinalCta() {
  return <section aria-labelledby="cierre-title" className="w-full bg-coral-deep" data-id="element-216" data-mp="1np9hiycfl5ei">
      <div className="mx-auto max-w-3xl px-5 py-16 text-center sm:px-8 lg:py-24" data-id="element-217" data-mp="1nn59q5bevm8y">
        <svg viewBox="0 0 120 4" preserveAspectRatio="none" className="mx-auto h-1 w-16" aria-hidden data-id="element-218" data-mp="1slzu3bp11iv6">
          <line x1="2" y1="2" x2="118" y2="2" stroke="#FFFFFF" strokeOpacity="0.7" strokeWidth="2" strokeLinecap="round" strokeDasharray="7 6" vectorEffect="non-scaling-stroke" data-id="element-219" data-mp="1eqe9rhtqnn93" />
        </svg>
        <h2 id="cierre-title" className="mt-5 font-serif text-[2.1rem] font-semibold leading-[1.1] text-white text-balance sm:text-[3rem]" data-id="element-220" data-mp="14s87v07xmh48">
          Elegí tu primer modelo y empezá a coser
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[1.1rem] leading-relaxed text-white sm:text-[1.2rem]" data-id="element-221" data-mp="342zlm53jvto5">
          310 moldes (31 modelos × 10 talles), de recién nacido a 4 años, para coserles a tus nietos, a tus hijos o
          para vender.
        </p>
        <div className="mx-auto mt-9 flex w-full min-w-0 max-w-full justify-center" data-id="element-222" data-mp="3tewhil8f0s5h">
          <CheckoutButton id="final-cta" label={BUY_LABEL} size="lg" tone="inverse" data-id="element-223" data-mp="b0586r9ml0zm" />
        </div>
        <GuaranteeNote tone="dark" className="mx-auto mt-6 max-w-md" data-id="element-224" data-mp="714pr9v280d5" />
      </div>
    </section>;
}